import React, { useEffect, useState, useRef } from "react";
import * as ReactDOM from 'react-dom/client';
import validator from 'validator';
import { TextField, Alert, Box, Button, Card, CardActions, CardHeader, Container, Grid, Paper, Typography, Checkbox, ToggleButton, ToggleButtonGroup, Stack, FormControl, Select, MenuItem, Input, InputLabel, FormHelperText, OutlinedInput } from "@mui/material";
import { ThemeProvider, createTheme, styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import CssBaseline from '@mui/material/CssBaseline';
import ListItemIcon from '@mui/material/ListItemIcon';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { // buttons / links / icons styles
  SignInButtonsStyle,
  ToggleButtonWithIcon,
  SimpleButtonStyle,
  AfterFormText,
  ResetStyleButton,
  CustomGoogleIcon,
  CustomFacebookIcon,
  CustomTwitterIcon
} from './components/ui-btns-links';
import { Item, GrayText, TitleText, SimpleText, OrSeparator } from './components/ui-text'; // buttons and links styles
import { InputWrapStyles, InputStyles, LabelStyles, PasswordInputField, StyledPasswordChecklist, ValidateText, CircleInputWrapStyles } from './components/ui-form-elements'; // input styles
import { LogoBlock, BgImage } from './components/ui-site'; // background image + logo
import { RegProgressBar } from './components/ui-progress-bar'; // Progress Bar after logo

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';

// CUSTOMIZE ANY UI BUTTON
import {
  FacebookLoginButton,
  GoogleLoginButton,
  GithubLoginButton,
  AmazonLoginButton,
  InstagramLoginButton,
  LinkedInLoginButton,
  MicrosoftLoginButton,
  TwitterLoginButton,
  AppleLoginButton,
} from 'react-social-login-buttons';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { FacebookAuthProvider, getAuth, GoogleAuthProvider, signInWithPopup, TwitterAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword, deleteUser } from "firebase/auth";
import { ImagesDropzone } from "./components/imagesDropzone";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyABiGSb5ieLNToIKJSpZSUx0hjU80dATMk",
  authDomain: "monad-social.firebaseapp.com",
  projectId: "monad-social",
  storageBucket: "monad-social.appspot.com",
  messagingSenderId: "980131745797",
  appId: "1:980131745797:web:3e952e4f609465404ecc6c",
  measurementId: "G-X74R0YZYK1"
};

/*
const firebaseConfig = {
  apiKey: "AIzaSyBEe1Z3tL7yWPc4kjavuotlnHVnd9BD6P4",
  authDomain: "monadauthen.firebaseapp.com",
  projectId: "monadauthen",
  storageBucket: "monadauthen.appspot.com",
  messagingSenderId: "414089043375",
  appId: "1:414089043375:web:c7e477a72b8f98d729635a"
};
*/

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const twitterProvider = new TwitterAuthProvider();
const facebookProvider = new FacebookAuthProvider();

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "#19242E",
    },
  },
  typography: {
    fontFamily: '"DM Sans", sans-serif',
  },
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        h1: 'h2',
        h2: 'h2',
        h3: 'h2',
        h4: 'h2',
        h5: 'h2',
        h6: 'h2',
        subtitle1: 'h2',
        subtitle2: 'h2',
        body1: 'p',
        body2: 'span',
      },
    },
  },
});
// const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export function CreateAccount(props) {
  if (!props.nonce) {
    return;
  }
  const siteAjaxUrl = '/wp-admin/admin-ajax.php';
  //const siteAjaxUrl = 'https://dev1.monad.social/wp-admin/admin-ajax.php';
  const [user, setUser] = useState(null);
  const [socialLogin, setSocialLogin] = useState(false);
  const [regStep, setRetStep] = useState(1);

  const signInWithPassword = async (email) => {
    // console.log('current password', password);
    if (!currentPasswordIsValid.current) {
      return;
    }
    createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed up 
        const user = userCredential.user;
        console.log('user', user);
        setUser(user);
        deleteUser(user).then(() => {
          // User deleted.
          console.log('user deleted from Firebase');
        }).catch((error) => {
          // An error ocurred
          // ...
          console.log('error', error.code, error.message);
        });
        handleRegStep(4);
      })
      .catch((error) => {
        console.log('error', error.code, error.message);
        if (error.code == 'auth/email-already-in-use') {
          signInWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
              // Signed in 
              const user = userCredential.user;
              console.log('user', user);
              setUser(user);
              deleteUser(user).then(() => {
                // User deleted.
                console.log('user deleted from Firebase');
              }).catch((error) => {
                // An error ocurred
                // ...
                console.log('error', error.code, error.message);
              });
              handleRegStep(4);
            })
            .catch((error) => {
              const errorCode = error.code;
              const errorMessage = error.message;
              console.log('error', error.code, error.message);
            });
        }
      });
  }

  const signInWithGoogle = async () => {
    try {
      const res = await signInWithPopup(auth, googleProvider);
      const user = res.user;
      console.log('user', user);
      setUser(user);
      setRegEmailaddress(user.email);
      setPreviewImageFile(user.photoURL.replace('s96', 's300'));
      setSocialLogin(true);
      setProfileUsername(validator.trim(user.displayName).replace(/\s+/g,"").toLowerCase());
      deleteUser(user).then(() => {
        // User deleted.
        console.log('user deleted from Firebase');
      }).catch((error) => {
        // An error ocurred
        // ...
        console.log('error', error.code, error.message);
      });
      handleRegStep(3);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const signInWithTwitter = async () => {
    try {
      const res = await signInWithPopup(auth, twitterProvider);
      const user = res.user;
      console.log('user', user);
      setUser(user);
      setRegEmailaddress(user.email);
      setPreviewImageFile(user.photoURL.replace('_normal', ''));
      setSocialLogin(true);
      setProfileUsername(validator.trim(user.displayName).replace(/\s+/g,"").toLowerCase());
      deleteUser(user).then(() => {
        // User deleted.
        console.log('user deleted from Firebase');
      }).catch((error) => {
        // An error ocurred
        // ...
        console.log('error', error.code, error.message);
      });
      handleRegStep(3);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const signInWithFacebook = async () => {
    try {
      const res = await signInWithPopup(auth, facebookProvider);
      const user = res.user;
      console.log('user', user);
      setUser(user);
      setRegEmailaddress(user.email);
      setPreviewImageFile(user.photoURL + '?height=300&width=300&type=large');
      setSocialLogin(true);
      setProfileUsername(validator.trim(user.displayName).replace(/\s+/g,"").toLowerCase());
      deleteUser(user).then(() => {
        // User deleted.
        console.log('user deleted from Firebase');
      }).catch((error) => {
        // An error ocurred
        // ...
        console.log('error', error.code, error.message);
      });
      handleRegStep(3);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  const createCircle = async () => {
    const formData = new FormData();
    

    formData.append('action', 'theclub_create_circle_on_reg');
    formData.append('nonce', props.nonce);
    formData.append('username', profileUsername);
    formData.append('circleName', circleName);
    formData.append('circleDescription', circleDescription);
    //circle avatar
    if (imageAvatarCircle.length > 0) {
      console.log('imageAvatarCircle:', imageAvatarCircle);
      formData.append('avatarFile', imageAvatarCircle[0].file);
    }
    //circle banner
    if (imageCircleBanner.length > 0) {
      formData.append('coverFile', imageCircleBanner[0].file);
    }

    console.log('formData:', formData);
    const requestOptions = {
      method: 'POST',
      body: formData,
    };

    setCreatingCircle(true);
    await fetch(siteAjaxUrl, requestOptions)
      .then((res) => {
        //setCreatingCircle(false);
        return res.json();
      })
      .then((data) => {
        console.log('data:', data);
        if (!user.emailVerified || data.sign_in_provider == 'password') {
          handleRegStep(6);
        } else {
          // or login when reg with social accounts
          //setTimeout(() => {
            window.location.href = "/circle/" + data.slug;
          //}, 2000)
        }
        
      });
  }

  const checkExistingAccount = async () => {
    console.log('user', user);
    var displayName = 'test user';
    if (user.hasOwnProperty('displayName') && user.displayName) {
      displayName = user.displayName;
    }
    console.log('displayName', displayName);
    const formData = new FormData();
    // user avatar
    if (!user.photoURL) {
      formData.append('file', imageList[0].file);
      //formData.append('filename', 'abc.jpg');
    } else {
      if (imageList.length > 0) {
        formData.append('file', imageList[0].file);
        //formData.append('filename', 'abc.jpg');
      }
    }

    formData.append('action', 'theclub_check_exiting_account');
    formData.append('nonce', props.nonce);
    formData.append('displayName', displayName);
    formData.append('accessToken', user.accessToken);
    formData.append('password', password);
    formData.append('username', profileUsername);
    formData.append('accountType', view);
    formData.append('weblinks', JSON.stringify(weblinks));
    formData.append('phone', phone);
    formData.append('bio', bio);

    //console.log('formData:', formData);
    const requestOptions = {
      method: 'POST',
      body: formData,
      //headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      /*body: JSON.stringify({ 
        action: "theclub_check_exiting_account", 
        nonce: props.nonce
      })*/
      /*
      body: 'action=theclub_check_exiting_account&nonce='+props.nonce+'&displayName='+displayName+'&accessToken='+user.accessToken+'&file='+imageList[0].file*/
    };

    setCreatingAccount(true);
    await fetch(siteAjaxUrl, requestOptions)
      .then((res) => {
        setCreatingAccount(false);
        return res.json();
      })
      .then((data) => {
        console.log('data:', data);
        //handleRegStep(5);
        console.log('user new:', user)
        // if user login with social user.emailVerified = true
        if (!user.emailVerified || data.sign_in_provider == 'password') {
          handleRegStep(5);// reg with email & password
        } else {
          // or login when reg with social accounts
          /*
          console.log('redirect to:', '/user/' + data.username);
          setTimeout(() => {
            window.location.href = "/user/" + data.username;
          }, 2000)
          */
          if (view == 'fan') {
            window.location.href = "/user/" + data.username;
          } else {
            handleRegStep(5);
          }
        }
      });
  }



  const handleRegStep = (step) => {
    console.log('step', step);
    setRetStep(step);
  }

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [regEmailaddress, setRegEmailaddress] = useState("");
  const [emailError, setEmailError] = useState('');
  const currentPasswordIsValid = useRef(false);
  const [passwordIsValid, setPasswordIsValid] = useState(false);
  const [profileUsername, setProfileUsername] = useState("");
  const [profileUsernameIsValid, setProfileUsernameIsValid] = useState("");
  const [view, setView] = React.useState('creator');
  const [activeButton, setActiveButton] = React.useState('creator');
  const [iconVisible, setIconVisible] = React.useState(false);
  const handleChange = (event, nextView) => {
    setView(nextView);
  };
  const [weblink, setWeblink] = React.useState('');
  const [phone, setPhone] = React.useState('');
  const [phoneIsValid, setPhoneIsValid] = useState('');
  const [bio, setBio] = React.useState('');
  const [circleName, setCircleName] = React.useState('');
  const [circleDescription, setCircleDescription] = React.useState('');
  const [emailErrorText, setEmailErrorText] = React.useState('Invalid email address');

  const checkExistingUsername = async (username) => {
    const userInputField = document.getElementById('username-outlined-basic');
    const formData = new FormData();
    formData.append('action', 'theclub_check_exiting_username');
    formData.append('nonce', props.nonce);
    formData.append('username', username);
    const requestOptions = {
      method: 'POST',
      body: formData,
    };

    await fetch(siteAjaxUrl, requestOptions)
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        // console.log('data.usernameExists:', data);
        if (!data.usernameExists && profileUsername.length > 2 && profileUsername.length <= 20) {
          setProfileUsernameIsValid(true);
          if (userInputField) {
            userInputField.parentNode.parentNode.classList.add('is-valid');
            userInputField.parentNode.parentNode.classList.remove('is-error');
          }
        } else {
          setProfileUsernameIsValid(false);
          if (userInputField) {
            userInputField.parentNode.parentNode.classList.add('is-error');
            userInputField.parentNode.parentNode.classList.remove('is-valid');
          }
        }
      });
  }

  // set class for error/valid style
  const validElementClass = (variable, element, e) => {
    // console.log('variable:', variable, ':', e, e.target.value);
    if ((variable == false) || (e && e.target && e.target.value.length < 3)) {
      element.classList.add('is-error');
      element.classList.remove('is-valid');
    } else if (variable == true) {
      element.classList.add('is-valid');
      element.classList.remove('is-error');
    } else {
      element.classList.remove('is-valid', 'is-error');
    }
  };

  // validateEmail
  const validateEmail = async (e) => {
    let isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
    if (!isValid) {
      setEmailErrorText('Invalid email address');
      setEmailError(true);
    } else {
      // API call to check in DB
      const formData = new FormData();
      formData.append('action', 'theclub_check_exiting_email');
      formData.append('nonce', props.nonce);
      formData.append('email', e);
      const requestOptions = {
        method: 'POST',
        body: formData,
      };
  
      isValid = await fetch(siteAjaxUrl, requestOptions)
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          //console.log('data.emailExists:', data);
          
          if (!data.emailExists) {
            setEmailError(false);
          } else {
            setEmailErrorText('Email address has been used');
            setEmailError(true);
          }

          return data.emailExists;
      });
      // end of API call to check in DB
      
    }
    //console.log('email valid:', isValid);
    return isValid;
  };
  //submit btn validate
  const checkAndSubmit = (e, step) => {
    e.preventDefault();
    const isValidEmail = validateEmail(regEmailaddress);
    if (!isValidEmail) {
      console.log('Form is invalid! Please check the fields...');
    } else {
      handleRegStep(step);
    }
  };
  // user name validate
  const validateUserName = (inputText) => {
    //setProfileUsername(validator.trim(inputText))
    setProfileUsername(validator.trim(inputText).toLowerCase().replace(/[^0-9a-z_]/g,""));
  }

  // phone validate
  const validatePhone = (phoneNumber) => {
    const isValidPhoneNumber = validator.isMobilePhone(phoneNumber, 'any')
    return isValidPhoneNumber;
  };
  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');;
    setPhone(value);
    setPhoneIsValid(validatePhone(value));
  };

  // for user avatar
  const [imageList, setImageList] = useState([]);
  const [previewImageFile, setPreviewImageFile] = React.useState('');
  useEffect(() => {
    imageList.forEach((image, index) => {
      console.log('image profile', image);
      setPreviewImageFile(URL.createObjectURL(image.file));
    });
  }, [imageList]);
  // for circle avatar
  const [imageAvatarCircle, setImageAvatarCircle] = useState([]);
  const [previewImageFileCircle, setPreviewImageFileCircle] = React.useState('');
  useEffect(() => {
    imageAvatarCircle.forEach((image, index) => {
      console.log('image circle', image);
      setPreviewImageFileCircle(URL.createObjectURL(image.file));
    });
  }, [imageAvatarCircle]);
  //for circle banner
  const [imageCircleBanner, setimageCircleBanner] = useState([]);
  const [previewImageFileBanner, setPreviewImageCircleBanner] = React.useState('');
  useEffect(() => {
    imageCircleBanner.forEach((image, index) => {
      console.log('image banner', image);
      setPreviewImageCircleBanner(URL.createObjectURL(image.file));
    });
  }, [imageCircleBanner]);

  // password status
  const setCurrentPasswordStatus = (isValid) => {
    currentPasswordIsValid.current = isValid;
    setPasswordIsValid(isValid);
  }

  const [weblinks, setWeblinks] = React.useState({
    facebook: '',
    twitter: '',
    instagram: '',
    youTube: '',
    linkedIn: '',
    whatsapp: '',
  });
  const [socialLinks, setSocialLinks] = useState(1);
  const increaseSocialLinks = () => {
    setSocialLinks(socialLinks + 1);
  }
  const updateSocialLinks = (socialLinks) => {
    Object.keys(socialLinks).map(key => {
      if (key) {
        //console.log('key', key, 'value', socialLinks[key]);
        //if (socialLinks[key]) {
        setWeblinks(prevState => ({
          ...prevState, [key]: socialLinks[key]
        }));
        //}
      }
    })
    //console.log('socialLinks', socialLinks);
  }
  useEffect(() => {
    //console.log('weblinks', weblinks);
  }, [weblinks]);
  useEffect(() => {
    checkExistingUsername(profileUsername);
  }, [profileUsername]);
  useEffect(() => {
    // console.log('social Login:', socialLogin);
  }, [socialLogin]);

  const [creatingAccount, setCreatingAccount] = useState(false);
  const [creatingCircle, setCreatingCircle] = useState(false);
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Container sx={{
        minHeight: '100vh',
        maxWidth: '662px',
      }} maxWidth={false} disableGutters>

        {/* background image */}
        <BgImage />

        <Box sx={{
          p: 2,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '30px'
        }} >
          <Button
            sx={ResetStyleButton}
            className='width-auto x-auto'
            variant="contained"
            onClick={() => { window.location.href = "/" }}
          >
            <LogoBlock step={regStep} />
          </Button>
          <RegProgressBar view={view} currentStep={regStep} isSocialLogin={socialLogin} />
          {regStep == 1 && (
            <>
              <Box sx={{
                textAlign: 'center',
                fontSize: 24,
                fontWeight: 500
              }}>
                <Box>Start by selecting</Box>
                <Box>Monad Profile Category</Box>
              </Box>
              <Stack spacing={2}>
                <Item>
                  <ToggleButtonGroup
                    orientation="vertical"
                    value={view}
                    exclusive
                    onChange={handleChange}
                    sx={{
                      gap: '20px'
                    }}
                  >
                    <ToggleButtonWithIcon
                      value="creator"
                      label="Creator"
                      isActive={activeButton === 'creator'}
                      onClick={() => {
                        setActiveButton('creator');
                        setIconVisible(!iconVisible);
                      }}
                    />
                    <ToggleButtonWithIcon
                      value="fan"
                      label="Fan"
                      isActive={activeButton === 'fan'}
                      onClick={() => {
                        setActiveButton('fan');
                        setIconVisible(!iconVisible);
                      }}
                    />
                  </ToggleButtonGroup>
                </Item>
                <Item sx={{
                  marginTop: '30px !important'
                }}>
                  <Button variant="contained" onClick={() => handleRegStep(2)} sx={SimpleButtonStyle}>GET STARTED</Button>
                </Item>
                <Item sx={{
                  p: '4px'
                }}>
                  <Box sx={AfterFormText}>
                    Already have a profile?
                    <Button
                      sx={{
                        ...ResetStyleButton,
                        textDecoration: 'underline'
                      }}
                      onClick={() => { window.location.href = "/login" }
                      }>
                      Log in here
                    </Button>
                  </Box>
                </Item>
              </Stack>
            </>
          )}
          {regStep == 2 && (
            <>
              <Box sx={{
                textAlign: 'center',
                fontSize: 24,
                fontWeight: 500
              }}>
                <Box sx={{
                  textTransform: 'capitalize',

                }}>{view} Profile Set Up</Box>
                <Box sx={GrayText}>Choose login method.</Box>
              </Box>
              <Box display="flex" alignItems="center" flexDirection="column" sx={{
                maxWidth: '300px',
                width: '100%',
                m: '0 auto'
              }}>
                <ToggleButtonGroup orientation="vertical" sx={{
                  alignItems: 'center',
                  gap: '10px',
                  width: '100%',
                }}>
                  <GoogleLoginButton
                    style={SignInButtonsStyle}
                    activeStyle={{
                      background: 'rgb(40, 46, 54)',
                    }}
                    icon={CustomGoogleIcon}
                    iconSize={30}
                    onClick={signInWithGoogle}
                    text="Continue with Google" />
                  <FacebookLoginButton
                    style={SignInButtonsStyle}
                    activeStyle={{
                      background: 'rgb(40, 46, 54)',
                    }}
                    icon={CustomFacebookIcon}
                    iconSize={30}
                    onClick={signInWithFacebook}
                    text="Continue with Facebook" />
                  <TwitterLoginButton
                    style={SignInButtonsStyle}
                    activeStyle={{
                      background: 'rgb(40, 46, 54)',
                    }}
                    icon={CustomTwitterIcon}
                    iconSize={30}
                    onClick={signInWithTwitter}
                    text="Continue with X (Twitter)" />
                </ToggleButtonGroup>

                <OrSeparator />
                <Box width={'100%'} component="form">
                  <Stack spacing={2}>
                    <FormControl variant="filled">
                      <TextField
                        className={emailError ? 'is-error' : ''}
                        id="email-filled-basic"
                        label="Email Address"
                        variant="filled"
                        sx={InputWrapStyles(emailError)}
                        required
                        InputProps={{
                          type: 'email',
                          style: InputStyles,
                        }}
                        InputLabelProps={{
                          style: LabelStyles,
                        }}
                        onChange={(e) => {
                          validateEmail(e.target.value) && setRegEmailaddress(e.target.value);
                          validElementClass(!emailError, e.target.parentNode.parentNode);
                        }}
                      />

                      {emailError && <ValidateText textString={emailErrorText} />}
                    </FormControl>
                    <Item>
                      <Button
                        variant="contained"
                        type="submit"
                        onClick={(e) => checkAndSubmit(e, 3)}
                        sx={{ ...SimpleButtonStyle, opacity: emailError ? 0.5 : 1 }}
                        disabled={Boolean(emailError)}
                      >
                        Continue
                      </Button>
                    </Item>
                    <Item sx={AfterFormText}>
                      Already have a profile?
                      <Button
                        sx={{
                          ...ResetStyleButton,
                          textDecoration: 'underline'
                        }}
                        onClick={() => { window.location.href = "/login" }}>
                        Log in here
                      </Button>
                    </Item>
                  </Stack>
                </Box>
              </Box>
            </>
          )}
          {regStep == 3 && (
            <>
              <Box sx={TitleText}>
                {socialLogin ? 'Confirm' : 'Add'} {view} Profile Details ({(view == 'fan') ? '1' : '1'}/{(view == 'fan' || socialLogin) ? '3' : '4'})
              </Box>
              <Box sx={SimpleText('#828a99')}>
                Your Profile Username will be used to generate your unique Profile URL and for your community identity on live chat, social feed and communication. You can change your Username later but you cannot change your unique URL.
              </Box>
              <Box component="form" noValidate autoComplete="off">
                <Stack direction="row" flexWrap="wrap"
                  sx={{
                    gap: '20px 30px'
                  }}
                >
                  <Item
                    sx={{
                      flexBasis: '100%'
                    }}
                  >
                    <TextField
                      sx={InputWrapStyles}
                      InputProps={{
                        type: 'email',
                        style: InputStyles,
                      }}
                      InputLabelProps={{
                        style: LabelStyles,
                      }}
                      fullWidth
                      id="regemailaddress-outlined-basic"
                      className="email-disabled"
                      label="Email Address"
                      variant="outlined"
                      value={regEmailaddress}
                      disabled
                    />
                  </Item>
                  <Box
                    sx={{
                      position: 'relative',
                      flexBasis: {
                        xs: '100%',
                        md: 'calc(50% - 15px)'
                      }
                    }}
                  >
                    <TextField
                      sx={InputWrapStyles}
                      InputProps={{
                        style: InputStyles,
                      }}
                      InputLabelProps={{
                        style: LabelStyles,
                      }}
                      fullWidth
                      id="username-outlined-basic"
                      label="Profile username"
                      value={profileUsername}
                      variant="filled"
                      onBlur={(e) => {
                        validateUserName(e.target.value);
                      }}
                      onPaste={(e) => {
                        validateUserName(e.target.value);
                      }}
                      onChange={(e) => {
                        validateUserName(e.target.value);
                      }}
                    />
                    {(!profileUsernameIsValid && profileUsername.length >= 3 && profileUsername.length <= 20) && <ValidateText textString={'This username is taken. Use another one to continue'} />}
                    {(profileUsername.length <= 2) && <ValidateText textString={'username is too short'} />}
                    {(profileUsername.length >= 21) && <ValidateText textString={'username is too long'} />}
                  </Box>
                  <Box
                    sx={{
                      flexBasis: {
                        xs: '100%',
                        md: 'calc(50% - 15px)'
                      }
                    }}
                  >
                    {/* phoneIsValid */}
                    <TextField
                      sx={InputWrapStyles}
                      InputProps={{
                        style: InputStyles,
                        type: 'tel',
                        pattern: '[0-9]{3}-[0-9]{3}-[0-9]{4}',
                      }}
                      InputLabelProps={{
                        style: LabelStyles,
                      }}
                      fullWidth
                      id="phonenumber-outlined-basic"
                      label="Phone (optional)"
                      variant="filled"
                      onChange={(e) => {
                        handlePhoneChange(e);
                        validElementClass(phoneIsValid, e.target.parentNode.parentNode);
                        console.log('phoneIsValid:', phoneIsValid);
                      }}
                    />
                    {!phoneIsValid && <ValidateText textString={'Please enter a valid phone number'} />}
                  </Box>
                  {!user && (
                    <>
                      <Box
                        sx={{
                          flexBasis: {
                            xs: '100%',
                            md: 'calc(50% - 15px)'
                          }
                        }}
                      >
                        <PasswordInputField id="filled-password-input-1" label="Password" onChange={e => setPassword(e.target.value)} />
                        <Box
                          sx={{
                            marginTop: '5px'
                          }}
                        >
                          <StyledPasswordChecklist
                            password={password}
                            passwordAgain={passwordAgain}
                            setCurrentPasswordStatus={(isValid) => { setCurrentPasswordStatus(isValid) }}
                          />
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          flexBasis: {
                            xs: '100%',
                            md: 'calc(50% - 15px)'
                          }
                        }}
                      >
                        <PasswordInputField id="filled-password-input-2" label="Confirm password" onChange={e => setPasswordAgain(e.target.value)} />
                      </Box>
                    </>
                  )}
                  {/*
                      <Box>
                        <button
                          className="register__btn register__google"
                          onClick={signInWithPassword}
                        >
                          Signup with Email
                        </button>
                      </Box>
                      */}
                </Stack>
                <Item sx={{
                  m: '40px 0 20px'
                }}>
                  {user ? (
                    <Button sx={SimpleButtonStyle} fullWidth variant="contained" onClick={() => handleRegStep(4)} disabled={!profileUsernameIsValid}>Continue</Button>
                  ) : (
                    <Button sx={SimpleButtonStyle} fullWidth variant="contained" onClick={() => signInWithPassword(regEmailaddress)} disabled={!passwordIsValid || !profileUsernameIsValid}>Continue</Button>
                  )}
                </Item>
                <Item
                  sx={SimpleText('#828a99', 10, 700, 1.4)}
                >
                  By providing your telephone number and email, you consent to receive calls, texts, and emails from monad.social, PBC., including prerecorded messages and via automated methods. Msg & data rates may apply. Msg frequency may vary. For texts, reply STOP to opt-out & HELP for help. For emails, click the "unsubscribe link" in the footer of the email if you no longer wish to receive such emails. View <a href="#" target="blank">Terms of Service</a> and <a href="#" target="blank">Privacy Policy</a>.
                </Item>
              </Box>
            </>
          )}
          {regStep == 4 && (
            <>
              <Box sx={TitleText}>
                {/* Complete {view} Profile ({(!socialLogin) ? '2' : '3'}/{(view == 'fan' || socialLogin) ? '3' : '4'})<br/> */}
                {(view == 'fan') && (`Complete ${view} Profile (${(socialLogin) ? '3/3' : '2/3'})`)}
                {(view == 'creator') && (`Complete ${view} Profile (${(socialLogin) ? '2/3' : '2/4'})`)}
              </Box>
              <Box sx={SimpleText('#828a99')}>
                This information can be edited or added to later from your profile.
              </Box>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} className='grid-rows'>
                  <Grid item xs={12} md={6} className='grid-row'>
                    <Box className='grid-row image-drag'>
                      <Box sx={{
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '50%',
                        overflow: 'hidden',
                        pointerEvents: 'none',
                        '& img': {
                          objectFit: 'cover',
                          objectPosition: 'center'
                        },
                      }}>
                        {previewImageFile && <img src={previewImageFile} width="100%" height="100%" />}
                      </Box>
                      <Item>
                        <ImagesDropzone setImageList={setImageList} previewFile={previewImageFile} placeholderText={`Upload Your Profile Image<br />(required)<br /><div style= "font-size: 11px">Min. Dimensions (size): 300 x 300<br />File format: PNG or JPG<br />File size: Less than 32MB</div>`} />
                      </Item>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} className='grid-row grid-row-col2'>
                    <TextField
                      sx={InputWrapStyles}
                      InputProps={{
                        style: InputStyles,
                      }}
                      InputLabelProps={{
                        style: LabelStyles,
                      }}
                      id="bio-outlined-multiline-static"
                      label="Add bio (optional)"
                      multiline
                      rows={4}
                      onChange={e => setBio(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} className='grid-rows'>
                  {/*
                  <Grid item xs={12} md={12} className='grid-row'>
                  <Box sx={SimpleText('#828a99')}>
                    <Typography component={'span'} sx={{pr:1}}>Add socials, websites, etc</Typography>
                    <ExpandMore
                      expand={expanded}
                      onClick={handleExpandClick}
                      aria-expanded={expanded}
                      aria-label="show more"
                    >
                      <ExpandMoreIcon sx={{color: '#828a99'}}/>
                    </ExpandMore>
                    <Collapse in={expanded} timeout="auto" unmountOnExit>
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
                        <FacebookIcon sx={{ color: '#828a99', mr: 1, my: 2 }} />
                        <TextField id="input-with-sx-facebook" label="Facebook" variant="filled" 
                          sx={InputWrapStyles}
                          InputProps={{
                            style: InputStyles,
                          }}
                          InputLabelProps={{
                            style: LabelStyles,
                          }} 
                          placeholder="https://" 
                        />
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
                        <XIcon sx={{ color: '#828a99', mr: 1, my: 2 }} />
                        <TextField id="input-with-sx-twitter" label="Twitter" variant="filled"
                         sx={InputWrapStyles}
                         InputProps={{
                           style: InputStyles,
                         }}
                         InputLabelProps={{
                           style: LabelStyles,
                         }} 
                         placeholder="https://" 
                        />
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
                        <InstagramIcon sx={{ color: '#828a99', mr: 1, my: 2 }} />
                        <TextField id="input-with-sx-instagram" label="Instagram" variant="filled"
                          sx={InputWrapStyles}
                          InputProps={{
                            style: InputStyles,
                          }}
                          InputLabelProps={{
                            style: LabelStyles,
                          }} 
                          placeholder="https://" 
                        />
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
                        <YouTubeIcon sx={{ color: '#828a99', mr: 1, my: 2 }} />
                        <TextField id="input-with-sx-youtube" label="YouTube" variant="filled"
                          sx={InputWrapStyles}
                          InputProps={{
                            style: InputStyles,
                          }}
                          InputLabelProps={{
                            style: LabelStyles,
                          }} 
                          placeholder="https://" 
                        />
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
                        <LinkedInIcon sx={{ color: '#828a99', mr: 1, my: 2 }} />
                        <TextField id="input-with-sx-linkedin" label="LinkedIn" variant="filled"
                          sx={InputWrapStyles}
                          InputProps={{
                            style: InputStyles,
                          }}
                          InputLabelProps={{
                            style: LabelStyles,
                          }} 
                          placeholder="https://" 
                        />
                      </Box>
                      <Box sx={{ display: 'flex', alignItems: 'flex-end', mb: 2 }}>
                        <WhatsAppIcon sx={{ color: '#828a99', mr: 1, my: 2 }} />
                        <TextField id="input-with-sx-whatsapp" label="WhatsApp" variant="filled"
                          sx={InputWrapStyles}
                          InputProps={{
                            style: InputStyles,
                          }}
                          InputLabelProps={{
                            style: LabelStyles,
                          }} 
                          placeholder="https://" 
                        />
                      </Box>
                    </Collapse>
                  </Box>
                  </Grid>
                  */}
                  {
                    Array.from(
                      { length: socialLinks },
                      (_, i) => (
                        <AddSocialLink key={i} updateSocialLinks={updateSocialLinks} currentWeblinks={weblinks} />
                      )
                    )
                  }  
                </Grid>
                {socialLinks < 6 && (
                  <Box
                    sx={{
                      marginTop: '15px',
                      maxWidth: '305px'
                    }}
                  >
                    <Button
                      className="btn-add-social"
                      sx={InputWrapStyles}
                      variant="contained"
                      onClick={increaseSocialLinks}>
                      Add another
                    </Button>
                  </Box>
                )}
              </Box>
              <Box>
                <Stack spacing={2}>
                  <Item>
                    <Button
                      sx={SimpleButtonStyle}
                      fullWidth
                      // onClick={() => { (socialLogin && view == 'fan') ? checkExistingAccount() : handleRegStep(5); }}
                      //onClick={() => { (socialLogin && view == 'creator') ? handleRegStep(5) : checkExistingAccount() }}
                      onClick={checkExistingAccount}
                      disabled={!((user && user.photoURL) || previewImageFile)} >
                      {(socialLogin) ? ((view == 'fan') ? 'COMPLETE SIGN UP' : 'CONTINUE') : 'CONTINUE'} {creatingAccount ? <CircularProgress color="inherit" size={16} sx={{ml:2}} /> : ''}
                    </Button>
                  </Item>
                </Stack>
              </Box>
            </>
          )}

          {(regStep == 5 && view == 'creator') && (
            <>
              <Box sx={TitleText}>
                Create Circle or Do Later ({socialLogin ? '3/3' : '3/4'})
              </Box>
              <Typography sx={SimpleText('#828a99')}>
                Circles are the name we use for channels.<br />
                You have to create your Circle to live stream and make money. You can change the images and description later in your Dashboard. Let’s do this!
              </Typography>
              <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2} className='grid-rows'>
                  <Grid item xs={12} md={6} className='grid-row'>
                    <Box className='grid-row image-drag'>
                      <Box sx={{
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '50%',
                        overflow: 'hidden',
                        pointerEvents: 'none',
                        '& img': {
                          objectFit: 'cover',
                          objectPosition: 'center'
                        },
                      }}>
                        {previewImageFileCircle && <img src={previewImageFileCircle} width="100%" height="100%" />}
                      </Box>
                      <Item>
                        <ImagesDropzone setImageList={setImageAvatarCircle} previewFile={previewImageFileCircle} placeholderText={`Upload Circle Profile Image<br />(required)<br /><div style= "font-size: 11px">Min. Dimensions (size): 300 x 300<br />File format: PNG or JPG<br />File size: Less than 32MB</div>`} />
                      </Item>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} className='grid-row grid-row-col2 grid-row--height-auto'>
                    <Item sx={{ marginBottom: '20px' }}>
                      <TextField
                        sx={InputWrapStyles}
                        InputProps={{
                          style: InputStyles,
                        }}
                        InputLabelProps={{
                          style: LabelStyles,
                        }}
                        id="circle-name"
                        label="Circle Name"
                        onChange={e => setCircleName(e.target.value)}
                      />
                    </Item>
                    <TextField
                      sx={InputWrapStyles}
                      InputProps={{
                        style: InputStyles,
                      }}
                      InputLabelProps={{
                        style: LabelStyles
                      }}
                      id="bio-outlined-multiline-static"
                      label={
                        <span dangerouslySetInnerHTML={{ __html: 'Add Circle Description<br/><span>(required)</span>' }} />
                      }
                      multiline
                      rows={4}
                      onChange={e => setCircleDescription(e.target.value)}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box>
                <Box className='grid-row image-drag image-drag--simple'>
                  <Box sx={{
                    position: 'absolute',
                    inset: 0,
                    overflow: 'hidden',
                    pointerEvents: 'none',
                    '& img': {
                      objectFit: 'cover',
                      objectPosition: 'center'
                    },
                  }}>
                    {previewImageFileBanner && <img src={previewImageFileBanner} width="100%" height="100%" />}
                  </Box>
                  <Item>
                    <ImagesDropzone
                      setImageList={setimageCircleBanner}
                      previewFile={previewImageFileBanner}
                      placeholderText={'Upload Banner Image<br>(required)'}
                      isCircleBanner={true}
                    />
                  </Item>
                </Box>
              </Box>
              <Box>
                <Stack spacing={2}>
                  <Item>
                    <Button
                      sx={SimpleButtonStyle}
                      fullWidth
                      //onClick={() => { socialLogin ? checkExistingAccount() : handleRegStep(6) }}
                      onClick={createCircle}
                      disabled={!(circleName && circleDescription && imageAvatarCircle && previewImageFileBanner)}
                    >
                      {socialLogin ? 'COMPLETE SETUP' : 'CONTINUE'} {creatingCircle ? <CircularProgress color="inherit" size={16} sx={{ml:2}} /> : ''}
                    </Button>
                  </Item>
                  <Item>
                    <Button
                      sx={{
                        ...ResetStyleButton,
                        padding: '9px 0',
                        textDecoration: 'underline'
                      }}
                      className='is-button'
                      //onClick={() => { socialLogin ? checkExistingAccount() : handleRegStep(6) }}
                      onClick={()=>{window.location.href = "/user/" + profileUsername;}}
                    >
                      DO LATER
                    </Button>
                  </Item>
                </Stack>
              </Box>
            </>
          )}
          {!socialLogin && ((regStep == 5 && view == 'fan') || (regStep == 6 && view == 'creator')) && (
            <>
              <Box sx={TitleText}>
                Confirm Email {(regStep == 5 && view == 'fan') ? '(3/3)' : '(4/4)'}
              </Box>
              <Box>
                <Stack spacing={2}>
                  <Box
                    sx={{
                      paddingBottom: '17px',
                      borderBottom: '1px solid rgba(255, 255, 255, 0.35)',

                    }}
                  >
                    <svg width="72" height="61" viewBox="0 0 72 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.97668 14.002C5.43304 13.9608 3.93689 14.5652 2.81644 15.6827C1.69599 16.8003 1.04274 18.3396 1 19.9631V54.0369C1.04274 55.6604 1.69599 57.1997 2.81644 58.3173C3.93689 59.4348 5.43304 60.0392 6.97668 59.998H65.0292C66.5718 60.0376 68.0665 59.4324 69.1856 58.3151C70.3048 57.1977 70.9573 55.6593 71 54.0369V19.9631C70.9573 18.3407 70.3048 16.8023 69.1856 15.6849C68.0665 14.5676 66.5718 13.9624 65.0292 14.002H6.97668Z" stroke="white" strokeWidth="1.5" />
                      <path d="M68.8231 15.8418L38.8814 39.8824C38.0179 40.5971 36.951 40.9857 35.8522 40.9857C34.7534 40.9857 33.6865 40.5971 32.823 39.8824L2.93384 15.8418" stroke="white" strokeWidth="1.5" />
                      <circle cx="36" cy="13" r="13" fill="#8140B7" />
                      <path d="M29.9336 13L33.8336 16.9L41.2003 9.53333" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: '20px',
                        marginTop: '10px',
                        '& span': {
                          fontWeight: 700,
                          color: '#dfb8ff'
                        },
                      }}
                    >
                      A confirmation link has been sent to <br />
                      <span>{regEmailaddress}</span>
                    </Typography>
                  </Box>
                  <Item
                    sx={{
                      textAlign: 'left',
                      color: '#fff',
                      '& p:not(:last-child)': {
                        marginBottom: '16px'
                      },
                    }}
                  >
                    <Typography
                      variant="body1">
                      To complete Sign Up, please check your email and click the confirmation link.
                    </Typography>
                    <Typography
                      variant="body1">
                      This is the last step in the Sign Up process and you will be directed to your new Profile or the Circle Page you were on.
                    </Typography>
                    <Typography
                      variant="body1">
                      Welcome to the Monad Community!
                    </Typography>
                  </Item>
                </Stack>
              </Box>
            </>
          )}
        </Box>
      </Container >
    </ThemeProvider >
  )
}

export default function AddSocialLink({ updateSocialLinks, currentWeblinks }) {
  const currentWeb = useRef('');
  const [isActive, setIsActive] = useState(false);
  const [weblink, setWeblink] = React.useState('');
  const [weblinks, setWeblinks] = React.useState({
    facebook: '',
    twitter: '',
    instagram: '',
    youTube: '',
    linkedIn: '',
    whatsapp: '',
  });

  const handleSelectClick = (e) => {
    setIsActive(true);
  };

  const setWebLinkValue = (link) => {
    /*const newlink = [{
      name: currentWeb.current,
      url: link,
    }];*/
    console.log(link);
    setWeblinks(prevState => ({
      ...prevState, [currentWeb.current]: link
    }));
  }
  const handleWeblinkChange = (event) => {
    setWeblink(event.target.value);
  };

  useEffect(() => {
    currentWeb.current = weblink;
    //console.log('inputing weblink', weblink);
    //console.log('inputing weblinks', weblinks);
    var newWebLinks = Object.fromEntries(Object.entries(weblinks).filter(([_, v]) => v != ''));
    //console.log('inputing newWebLinks', newWebLinks);
    if (Object.keys(newWebLinks).length === 0 && newWebLinks.constructor === Object) {
      newWebLinks = {
        [weblink]: '',
      }
    }
    updateSocialLinks(newWebLinks);
  }, [weblink, weblinks]);

  const [initWeblinks, setInitWeblinks] = React.useState({
    facebook: '',
    twitter: '',
    instagram: '',
    youTube: '',
    linkedIn: '',
    whatsapp: '',
  });
  useEffect(() => {
    setInitWeblinks(currentWeblinks);
    var webName = '';
    Object.keys(currentWeblinks).map(key => {
      if (!currentWeblinks[key] && !webName) {
        webName = key;
      }
    }
    )
    setWeblink(webName);
    //console.log('webName', webName);
  }, [])
  console.log('weblink:', weblink);
  return (
    <>
      <Grid item xs={12} md={6} className='grid-row'>
        <Item>
          <FormControl variant="filled" fullWidth sx={InputWrapStyles} className={`MuiSelect ${isActive ? 'is-active' : ''}`}>
            <InputLabel id="demo-simple-select-filled-label">Socials, Websites, etc</InputLabel>
            <Select
              labelId="demo-simple-select-filled-label"
              id="demo-simple-select-filled"
              value={weblink ? weblink : ''}
              onChange={handleWeblinkChange}
              onClick={handleSelectClick}
              IconComponent={props => (
                <svg {...props} className={`${props.className}`} width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 13L0 0H20L10 13Z" fill="#828A99" />
                </svg>
              )}
            >
              {!initWeblinks.facebook && (
                <MenuItem value="facebook">
                  <ListItemIcon>
                    <FacebookIcon />
                  </ListItemIcon>
                  Facebook
                </MenuItem>
              )}
              {!initWeblinks.twitter && (
                <MenuItem value="twitter">
                  <ListItemIcon>
                    <XIcon />
                  </ListItemIcon>
                  Twitter
                </MenuItem>
              )}
              {!initWeblinks.instagram && (
                <MenuItem value="instagram">
                  <ListItemIcon>
                    <InstagramIcon />
                  </ListItemIcon>
                  Instagram
                </MenuItem>
              )}
              {!initWeblinks.youTube && (
                <MenuItem value="youTube">
                  <ListItemIcon>
                    <YouTubeIcon />
                  </ListItemIcon>
                  YouTube
                </MenuItem>
              )}
              {!initWeblinks.linkedIn && (
                <MenuItem value="linkedIn">
                  <ListItemIcon>
                    <LinkedInIcon />
                  </ListItemIcon>
                  LinkedIn
                </MenuItem>
              )}
              {!initWeblinks.whatsapp && (
                <MenuItem value="whatsapp">
                  <ListItemIcon>
                    <WhatsAppIcon />
                  </ListItemIcon>
                  WhatsApp
                </MenuItem>
              )}
            </Select>
          </FormControl>
        </Item>
      </Grid>
      <Grid item xs={12} md={6} className='grid-row grid-row-col2'>
        <TextField
          sx={InputWrapStyles}
          InputProps={{
            style: InputStyles,
          }}
          InputLabelProps={{
            style: LabelStyles,
          }}
          id="bio-web-link"
          label="https://"
          onChange={e => setWebLinkValue(e.target.value)}
        />
      </Grid>
    </>
  );
}